import cn from 'classnames';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './MPRTitle.module.scss';

type MPRTitleProps = {
  className?: string;
};

export const MPRTitle: FC<MPRTitleProps> = (props) => {
  const { className } = props;

  return (
    <div className={cn(styles.container, className)}>
      <h4 className="h4">
        <FormattedMessage id="tooth.mpr.abbreviation" defaultMessage="MPR" />
      </h4>
      <p className="p3">
        <FormattedMessage
          id="tooth.mpr"
          defaultMessage="Multi-Planar Reconstruction"
        />
      </p>
    </div>
  );
};
